<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <div class="row">
                <div class="col col-md-12">
                  <pr-input-radio
                    [derrors]="derrors"
                    formControlName="realEstateLocationDuration"
                    direction="column"
                    [isDefault]="false"
                    columns="4"
                    [options]="realEstateLocationDurationOptions"
                    label="Durée de l’engagement de location"
                  >
                  </pr-input-radio>
                </div>
              </div>
              <div class="row">
                <div class="col col-md-12">
                  <pr-input-column label="Zone Pinel" [derrors]="derrors">
                    <input
                      formControlName="realEstatePinelAreaCode"
                      type="text"
                    />
                  </pr-input-column>
                </div>
              </div>
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
